<template>
    <div>
        <vx-card class="mb-8">
            <div class="vx-row mb-8">
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                <label class="text-sm opacity-100 text-bold">General</label>
                <vs-input type="search" placeholder="" v-model="filters['search']" class="mb-4 md:mb-0 w-full" />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                <label class="text-sm opacity-100 text-bold">Filter</label>
                <v-select :clearable="true" :reduce="option => option.value" label="name" :options="[
                    { name: 'Last 7 Days Orders', value: 'seven_days' },
                    { name: 'Overdue Orders', value: 'overdue' },
                    { name: 'Non UK', value: 'non_uk' }
                ]" v-model="filters['filter']" />
            </div>
        </div>
        </vx-card>
        <vx-card>
            <vs-table :data="order_formulations_list" id="work-order-create-select-formulation-section" :sst="true"
                @sort="handleSort">

                <template slot="thead">
                    <vs-th>ITS PRODUCT CODE</vs-th>
                    <vs-th>ITS PRODUCT NAME</vs-th>
                    <vs-th sort-key="required-by">SHIP BY DATE</vs-th>
                    <vs-th>TYPE</vs-th>
                    <vs-th>CUSTOMER ORDERS (Qty)</vs-th>
                    <vs-th>TOTAL ORDER QUANTITY (Kg)</vs-th>
                    <vs-th>MAX POSSIBLE PRODUCTION QUANTITY (Kg)</vs-th>
                    <vs-th>UNALLOCATED FG STOCK (Kg)</vs-th>
                    <vs-th>ACTION</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr v-if="Number(tr.no_formulation_stock_items) > 0" :data="tr" :key="indextr"
                        v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].formulation_code">
                            {{ data[indextr].formulation_code }}
                        </vs-td>

                        <vs-td :data="data[indextr].name">
                            {{ data[indextr].name }}
                        </vs-td>

                        <vs-td :data="data[indextr].name">
                            {{ data[indextr].oldest_item_required_by }}
                        </vs-td>

                        <vs-td :data="data[indextr].formulation_type">
                            {{ data[indextr].formulation_type }}
                        </vs-td>

                        <vs-td :data="data[indextr].number_of_customer_order">
                            {{ data[indextr].number_of_customer_order }}
                        </vs-td>

                        <vs-td :data="data[indextr].total_order_quantity">
                            {{ toFixed(data[indextr].total_order_quantity) }}
                        </vs-td>

                        <vs-td :data="data[indextr].max_products_possible">
                            {{ toFixed(data[indextr].max_products_possible) }}
                        </vs-td>

                        <vs-td>
                            {{ data[indextr].formulation_stock }}
                        </vs-td>

                        <vs-td>
                            <div class="vx-row">
                                <vx-tooltip v-if="checkIfRequestedDate(data[indextr].order_items)" class="ml-2"
                                    text="Special requested date" position="left">
                                    <vs-button size="small" color="danger" type="filled" icon-pack="feather"
                                        icon="icon-bell"></vs-button>
                                </vx-tooltip>
                                <!-- <vx-tooltip class="ml-2" text="RM stock/Formulation stock" position="left">
                                    <vs-button @click.stop="onCLickViewRmStock(data[indextr].id)" size="small"
                                        color="primary" type="filled" icon-pack="feather" icon="icon-box"></vs-button>
                                </vx-tooltip> -->
                            </div>
                        </vs-td>

                        <template class="expand-user" slot="expand">
                            <div class="con-expand-users w-full">
                                <vs-table :data="data[indextr].order_items" :hoverFlat="true" class="m-16">
                                    <template slot="thead">
                                        <vs-th width="10%" class="text-sm">ORDER DATE</vs-th>
                                        <vs-th width="20%" class="text-sm">REQUIRED BY</vs-th>
                                        <vs-th width="20%" class="text-sm">CUSTOMER ORDER CODE</vs-th>
                                        <vs-th width="20%" class="text-sm">CUSTOMER</vs-th>
                                        <vs-th width="20%" class="text-sm">PENDING CUSTOMER ORDER QTY (Kg)</vs-th>
                                        <vs-th width="10%" class="text-sm">ACTIONS</vs-th>
                                    </template>

                                    <template slot-scope="{data}">
                                        <vs-tr class="text-sm" :key="index_item" v-for="(tr_item, index_item) in data">

                                            <vs-td :data="tr_item.order_date">
                                                {{ tr_item.order_date }}
                                            </vs-td>

                                            <vs-td :data="tr_item.required_by">
                                                {{ tr_item.required_by || 'N/A' }}
                                            </vs-td>

                                            <vs-td :data="tr_item.product_order_code">
                                                {{ tr_item.product_order_code }}
                                            </vs-td>

                                            <vs-td :data="tr_item.company_name">
                                                {{ tr_item.company_name }}
                                            </vs-td>

                                            <vs-td :data="tr_item.pending_manufacture_quantity">
                                                {{ toFixed(tr_item.pending_manufacture_quantity) }}
                                            </vs-td>

                                            <vs-td>
                                                <div class="vx-row">
                                                    <vx-tooltip v-if="Number(tr.no_formulation_stock_items) > 0"
                                                        class="ml-2" text="Allocate from FG stock" position="left">
                                                        <vs-button
                                                            @click="onClickStockAssign(tr.formulation_stock_items, tr.id, tr_item.id)"
                                                            size="small" color="primary" type="filled" icon-pack="feather"
                                                            icon="icon-archive"></vs-button>
                                                    </vx-tooltip>
                                                    <vx-tooltip v-if="tr_item.requested_date" class="ml-2"
                                                        text="Special requested date" position="left">
                                                        <vs-button size="small" color="danger" type="filled"
                                                            icon-pack="feather" icon="icon-bell"></vs-button>
                                                    </vx-tooltip>
                                                </div>
                                            </vs-td>

                                        </vs-tr>
                                    </template>
                                </vs-table>
                            </div>
                        </template>
                    </vs-tr>
                </template>

            </vs-table>
        </vx-card>
        <assign-formulation-stock-from-work-order-pop-up v-on:refreshData="fetchOrderFormulations"
            ref="assignFormulationStockFromWorkOrderPopUp" />
    </div>
</template>
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const ManufacturingRepository = RepositoryFactory.get('manufacturing');
import Filter from "@/mixins/filter";
import Utils from "@/mixins/Utils";
import vSelect from "vue-select";

import AssignFormulationStockFromWorkOrderPopUp
    from "@/components/popups/manufacturing/formulation-stock/AssignFormulationStockFromWorkOrderPopUp";

export default {
    name: "AllocateFromStockToOrder",
    data() {
        return {
            order_formulations_list: [],
            filters: {},
            page: 1,
            total: 0,
            meta: {},
            perPage: 10,
            sort: '',
            descriptionItems: [10, 20, 50, 100],
        }
    },
    mixins: [Filter, Utils],
    components: {
        'v-select': vSelect,
        AssignFormulationStockFromWorkOrderPopUp
    },
    methods: {
        toFixed(number) {
            return Number(number).toFixed(2)
        },
        filterQueryUpdate() {
            this.fetchOrderFormulations()
        },
        async fetchOrderFormulations() {
            await this.$vs.loading({
                container: '#work-order-create-select-formulation-section',
                scale: 0.45
            });
            try {
                const { data } = await ManufacturingRepository.getFormulationsOrderList(this.filterQuery, this.sort, this.page, this.perPage, 0);
                this.order_formulations_list = data.data
            } catch (e) {
            }
            this.$vs.loading.close('#work-order-create-select-formulation-section > .con-vs-loading')
        },
        async onClickStockAssign(data, formulation_id, item_id) {
            this.$refs.assignFormulationStockFromWorkOrderPopUp.openPopup(data, formulation_id, item_id)
        },
        checkIfRequestedDate(arr) {
            return this.checkKeyHasOneNotNullValue(arr, 'requested_date')
        },
        changePage(index) {
            this.page = 1
            this.perPage = this.descriptionItems[index]
        },
        handleSort(key, active) {
            if (key) {
                active = (active === 'desc') ? "-" : '';
                this.sort = active + key;
                this.fetchOrderFormulations()
            }
        },
    },
    watch: {
        page() {
            this.fetchOrderFormulations()
        },
        perPage() {
            this.fetchOrderFormulations()
        }
    }
}
</script>
<style lang="">
    
</style>